import { locale } from "moment";
import "moment/locale/pt";
import "moment/locale/es";

import detectBrowserLanguage from "detect-browser-language";
import es from "./es.json";
import en from "./en.json";
import pt from "./pt.json";
import mx from "./es-MX.json";

const copies = {
  es,
  en,
  pt,
  mx,
};
const langs = {
  "es-ES": "es",
  es: "es",
  "en-EN": "en",
  en: "en",
  "pt-PT": "pt",
  pt: "pt",
  "es-MX": "mx",
  mx: "mx",
};

const lang = detectBrowserLanguage();
const langTag = langs[lang] || "en";

locale(langTag);

export function translate(str, data = {}) {
  const keys = str.split(/[.[\]'"]/).filter((e) => e);
  let copy = copies[langTag];

  try {
    keys.forEach((key) => {
      copy = copy[key];
    });

    Object.keys(data).forEach((dataKey) => {
      copy = copy.replace(`%${dataKey}%`, data[dataKey]);
    });

    return copy || "";
  } catch (e) {
    return "";
  }
}

export function getLanguage() {
  return langTag;
}
